import { Component } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { LocalizedRouterLinkPipe } from '@core/i18n/localized-router-link.pipe';

@Component({
  selector: 'app-regbr-tabs',
  standalone: true,
  imports: [RouterLink, RouterLinkActive, TranslocoPipe, LocalizedRouterLinkPipe],
  template: `
    <nav
      class="flex gap-1 border-b border-border"
      [attr.aria-label]="'pages.regbr.tabs.ariaLabel' | transloco"
    >
      <a
        [routerLink]="'/regbr' | localizedRouterLink"
        routerLinkActive
        #flowRla="routerLinkActive"
        [routerLinkActiveOptions]="{ exact: true }"
        class="relative px-5 py-3 text-sm font-semibold transition"
        [class.text-primary]="flowRla.isActive"
        [class.text-muted-foreground]="!flowRla.isActive"
        [class.hover:text-foreground]="!flowRla.isActive"
      >
        {{ 'pages.regbr.tabs.flow' | transloco }}
        <span
          class="absolute inset-x-3 -bottom-px h-0.5 rounded-full transition"
          [class.bg-primary]="flowRla.isActive"
          [class.bg-transparent]="!flowRla.isActive"
        ></span>
      </a>
      <a
        [routerLink]="'/regbr/metricas' | localizedRouterLink"
        routerLinkActive
        #metricsRla="routerLinkActive"
        class="relative px-5 py-3 text-sm font-semibold transition"
        [class.text-primary]="metricsRla.isActive"
        [class.text-muted-foreground]="!metricsRla.isActive"
        [class.hover:text-foreground]="!metricsRla.isActive"
      >
        {{ 'pages.regbr.tabs.metrics' | transloco }}
        <span
          class="absolute inset-x-3 -bottom-px h-0.5 rounded-full transition"
          [class.bg-primary]="metricsRla.isActive"
          [class.bg-transparent]="!metricsRla.isActive"
        ></span>
      </a>
    </nav>
  `,
})
export class RegbrTabsComponent {}
